__webpack_require__.p = "/BEETECH_PEDICOMIDA/";